import { render, staticRenderFns } from "./RestaurantCard.vue?vue&type=template&id=64d04aef&scoped=true"
import script from "./RestaurantCard.vue?vue&type=script&lang=ts"
export * from "./RestaurantCard.vue?vue&type=script&lang=ts"
import style0 from "./RestaurantCard.vue?vue&type=style&index=0&id=64d04aef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d04aef",
  null
  
)

export default component.exports